import React from 'react'
import h1 from "../../Images/New/FeatureVIdeo/1.gif"
import h2 from "../../Images/New/FeatureVIdeo/2.gif"
import h3 from "../../Images/New/FeatureVIdeo/3.gif"
import h4 from "../../Images/New/FeatureVIdeo/4.gif"
import h5 from "../../Images/New/FeatureVIdeo/5.gif"
import h6 from "../../Images/New/FeatureVIdeo/6.gif"
import h7 from "../../Images/New/FeatureVIdeo/7.gif"
import h8 from "../../Images/New/FeatureVIdeo/8.gif"

const FeatureVideo = () => {
  return (
    <>
      <div className="relative bg-white pt-12">
        <div className="text-center mb-6">
          <p className="text-4xl text-black font-bold">
            <span
              className="font-extrabold"
              style={{
                backgroundImage:
                  "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              EasyTDS
            </span>{" "}
            - Ultimate solution for seamless TDS management
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 max-w-7xl bg-[#f1f5f8] rounded-md px-6 py-6 mx-auto gap-8">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h1} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Generate TDS & TCS Returns with e-filing
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h3} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Download & Generate <br />
                  TDS Certificates
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h2} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Correction Returns
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h5} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Import / Export facility
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h7} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Online Data link with <br />
                  TRACES & ITD portal
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h4} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Default Prediction <br />
                  Data Analysis
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h6} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Challan E-payment
                </p>
              </div>
              <div className="bg-white flex items-center border-2 border-[#b5d0ff] py-3 px-3 rounded-lg shadow-xl hover:shadow-none duration-150">
                <img src={h8} alt="gif_Image" className="w-[40px]" />
                <p className="mb-0 text-black text-lg ml-3 font-semibold">
                  Bulk PAN Verification
                </p>
              </div>
            </div>
          </div>
          <div className="shadow-2xl rounded-xl">
            <iframe
              src="https://www.youtube.com/embed/WXD3zlS4Orc?si=AIrb13fkdAmxHv7U"
              title="Video"
              frameborder="0"
              className="w-full h-full sm:h-[368px] rounded-xl"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeatureVideo;